function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { breakpoints } from '../../../abstracts';
export const BaseSidePanelContainer = styled.div.withConfig({
  componentId: "aui__sc-z9cigt-0"
})(["height:auto;grid-area:side-panel;", "{overflow-y:auto;background-color:var(--aui-surface);margin-right:calc(-1 * var(--aui-spacing-300));padding:var(--aui-spacing-600) var(--aui-spacing-300);", "}", "{margin-right:calc(-1 * var(--aui-spacing-600));padding:var(--aui-spacing-600);}", "{margin-left:var(--aui-spacing-300);}"], breakpoints.md2, ({
  $showDivider
}) => $showDivider && `border-left: solid 1px var(--aui-outline-soft);`, breakpoints.lg, breakpoints.lgOnly);
export const SidePanelContainer = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(BaseSidePanelContainer, _extends({
  $showDivider: React.Children.count(children) > 0
}, rest), children);